/** @jsx jsx */
import { jsx } from 'theme-ui';

const Container = (props) => (
  <div
    sx={{
      width: '100%',
      bg: 'rgba(17, 43, 74, 0.75)',
      position: 'fixed',
      top: 0,
      bottom: 0,
      zIndex: 1,
      display: ['block', null, 'none'],
    }}
    {...props}
  />
);

export default Container;
